import {
  createSlice,
  createAsyncThunk,
  combineReducers,
  configureStore,
} from '@reduxjs/toolkit'
import md5 from 'blueimp-md5'
import store, { ActionParams, methods, RootState } from '.'
import { PARAMS, protoRoot } from '../protos'
import {
  WebStorage,
  SakiSSOClient,
  NEventListener,
  // SAaSS,
} from '@nyanyajs/utils'

import { SAaSS } from 'saass-js'

import { sakisso, staticPathDomain } from '../config'
import { userAgent } from './user'
import { storage } from './storage'
import { alert, prompt, snackbar } from '@saki-ui/core'
import { getI18n } from 'react-i18next'
import i18n from '../modules/i18n/i18n'
import { api } from '../modules/http/api'

export const modeName = 'saass'

let enErrorAlert: ReturnType<typeof alert> | undefined

// export let meowWhisperCoreSDK: MeowWhisperCoreSDK | undefined
const state: {
  sdk: SAaSS
  appToken: {
    baseUrl: string
    token: string
    deadline: number
  }
  nEventListener: NEventListener
} = {
  sdk: new SAaSS({}),
  appToken: {
    baseUrl: '',
    token: '',
    deadline: 0,
  },
  nEventListener: new NEventListener(),
}

state.sdk.on('AppTokenInvalid', () => {
  // console.log('AppTokenInvalid')
  store.dispatch(saassMethods.getAppToken())
})

export const saassSlice = createSlice({
  name: modeName,
  initialState: state,
  reducers: {
    init: (state, params: ActionParams<{}>) => {},
    setAppToken: (state, params: ActionParams<(typeof state)['appToken']>) => {
      state.appToken = params.payload
    },
  },
})

export const saassMethods = {
  Init: createAsyncThunk<
    void,
    void,
    {
      state: RootState
    }
  >(modeName + '/Init', (_, thunkAPI) => {
    const { config } = thunkAPI.getState()
    thunkAPI.dispatch(saassMethods.getAppToken())
  }),
  getAppToken: createAsyncThunk<
    void,
    void,
    {
      state: RootState
    }
  >(modeName + '/getAppToken', async (_, thunkAPI) => {
    const { saass } = thunkAPI.getState()

    console.log('getAppToken')

    const res = await api.v1.getAppToken({})
    console.log('getAppToken', res)
    if (res.code === 200) {
      store.dispatch(
        saassSlice.actions.setAppToken({
          baseUrl: staticPathDomain || '',
          token: res.data.appToken || '',
          deadline: Number(res.data.deadline),
        })
      )
      saass.sdk.setAppToken(
        staticPathDomain || '',
        res.data.appToken || '',
        Number(res.data.deadline)
      )
    }
  }),
}
